import { appendAddonsDataAction, setRequestedVersionAction } from 'editor/src/store/editorModules/addons/slice';
import { AddonData } from 'editor/src/store/editorModules/addons/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';

const appendAddonsDataOperation = (data: AddonData) => (dispatch: ThunkDispatch) => {
  if (!data) {
    return;
  }

  dispatch(appendAddonsDataAction(data));
  dispatch(setRequestedVersionAction(data.resultsVersion || 0));
};

export default appendAddonsDataOperation;
